























import {Vue, Component, Prop, Watch, Emit} from 'vue-property-decorator';
import { BarChart } from 'vue-morris';
import {blue, red, yellow} from "@/utils/colors";
import {Dashboard} from "@/services/BackendProxies";

@Component({components: {BarChart}})
export default class PCTroskoviPoGodinama extends Vue {
    @Prop() dashboard!: Dashboard;
    colors = [ blue, red ];
    data = [];

    @Watch('dashboard')
    onDataChanged(dashboard: Dashboard) {
        this.data = dashboard.pcPoGodinama;
    }
}
